// Client-facing "What's New" changelog.
// Dates are the real build dates (from version control). Keep newest first and
// NEVER have two entries with the same date — combine a day's updates into one release.
// To add a release, prepend a new object with an ISO date and benefit-focused bullets.
export const CHANGELOG = [
  {
    date: '2026-09-10',
    title: 'Renewal reminders & smarter matter tracking',
    items: [
      'Registered marks now show clear reminders for upcoming trademark maintenance and renewal deadlines — including a heads-up when a deadline has entered its late-filing grace period.',
      'Your trademarks now stay up to date automatically — new filings and recently registered marks appear in your portal on their own.',
      'Registered marks covered by a Protection Plan now always appear in your portal.',
      'Added a quick way to let us know if a trademark is missing from your portal so we can fix it right away.',
      'Made “forgot password” emails more reliable so you can always get back in.',
      'Fixed a display issue that could show the same mark twice and tidied up a date that occasionally showed incorrectly.',
    ],
  },
  {
    date: '2026-08-21',
    title: 'Your VIP Strategy Call, at a glance',
    items: [
      'Your Protection Plan page now shows your VIP Strategy Call history and when your next included call is available — and lets you book it right from the page.',
    ],
  },
  {
    date: '2026-08-20',
    title: 'Clearer onboarding guidance',
    items: [
      'Improved the guidance shown when your onboarding isn’t quite complete, so it’s clear what the next step is to get into your portal.',
    ],
  },
  {
    date: '2026-08-17',
    title: 'Early access & mobile polish',
    items: [
      'Rolled out early access to the client portal with a clearer welcome for our first clients.',
      'Polished the sign-in and welcome screens so they look and work better on phones.',
    ],
  },
  {
    date: '2026-08-16',
    title: 'Feedback, scheduling & accuracy',
    items: [
      'Added a Feedback button so you can send us a bug or an idea anytime.',
      'Refreshed the Book a Call page to make scheduling quicker.',
      'A range of accuracy improvements to how your trademarks, deadlines, and documents are linked and displayed.',
    ],
  },
  {
    date: '2026-08-15',
    title: 'Clearer status & your search decision',
    items: [
      'You can now record your decision on a search report — Proceed, I have questions, or Pause — right inside the portal.',
      'Registered marks now show openly without an extra click, and each trademark’s status is easier to read at a glance.',
    ],
  },
  {
    date: '2026-08-14',
    title: 'A redesigned “My Matters” & search report',
    items: [
      'Redesigned the My Matters overview so you can see each trademark’s stage at a glance — from onboarding all the way through registration.',
      'Introduced a clearer Search Report experience with an at-a-glance summary and our recommendation.',
      'Added USPTO office action deadline details and many improvements for viewing on phones and tablets.',
    ],
  },
  {
    date: '2026-07-02',
    title: 'Portal improvements',
    items: [
      'Behind-the-scenes updates to make the portal faster and more reliable.',
    ],
  },
];
